import * as React from 'react';
import { PhoneVideo } from './Video.s';

export const LogoVideo = () => (
  <PhoneVideo muted={true} autoPlay={true} loop={true} src={require('./medias/phoneLogo.mp4')} />
);



// WEBPACK FOOTER //
// src/app/src/components/Videos/LogoVideo.tsx